import axios from 'axios';
import Vue from 'vue'

export default {
    getTotalTurnover(month,year,isMonthly,isYearly){
        return axios.get('/api/reporting/turnover', { params: { month: month, year:year, isMonthly:isMonthly,isYearly:isYearly } } )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getPurchasesByBrand(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSalesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getQuantityByBrand(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalQuantitiesByBrand',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTopTenItems(page, pageSize,start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/topItems',{params: {page: page, pageSize: pageSize,start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getTotalSales(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/totalSales',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getOrdersStatus(start,end,countryId,cityId,customerId){
        return axios.get('/api/reporting/ordersStatus',{params: {start:start,end:end,countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getInvoicesStatus(countryId,cityId,customerId){
        return axios.get('/api/reporting/invoicesStatus',{params: {countryId:countryId,cityId:cityId,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSearchHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAccessHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/accessHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSyncHistory(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/syncHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getLastSynchronisationAccess(){
        return axios.get('/api/reporting/lastSynchronisationAccess')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSearchHistoryChartCustomerList(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistoryChart/customer/list',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getSearchHistoryChartSupplierList(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/searchHistoryChart/supplier/list',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
     },

    getOrderHistory(page, pageSize,start,end,customerId){

        return axios.get('/api/reporting/orderHistory',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })

        .then(response => {

            if (response && response.data) return response.data

        })

        .catch(error => {Vue.prototype.$snotify.error(error);})

    },

    getClaims(page, pageSize,start,end,customerId, claimTypeId, onlyOpenClaims, userId, refType){
        return axios.get('/api/reporting/claims',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, claimTypeId:claimTypeId, onlyOpenClaims:onlyOpenClaims, userId: userId, refType:refType} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAlerts(page, pageSize,start,end,customerId, alertType){
        return axios.get('/api/reporting/alerts',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId, alertType: alertType} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    setClaimIsClosed(claimId, isClosed) {

        return axios.post('/api/reporting/claims/close/' + claimId + '/' + isClosed)
            .then(response => {
                if (response && response.data) return response.data;
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
        

    },

    getClientDevices(page, pageSize,start,end,customerId){
        return axios.get('/api/reporting/client-devices',{params: {page: page, pageSize: pageSize,start:start,end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    authorizeDevice(deviceId, isAuthorized) {
        return axios.post('/api/reporting/client-devices/auth/' + deviceId + '/' + isAuthorized)
            .then(response => {
                if (response && response.data) return response.data;
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
    }
}